import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import UtilisateurCreation from "../../../components/Admin/Utilisateurs/UtilisateurCreation";
import UtilisateurVue from "../../../components/Admin/Utilisateurs/UtilisateurVue";
import UtilisateursCreationEnMasse from "../../../components/Admin/Utilisateurs/UtilisateursCreationEnMasse";

function AdminUtilisateurPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {utilisateurId} = useParams();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [utilisateur, setUtilisateur] = useState({});
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const modeOptions = {
        'creation': <UtilisateurCreation utilisateur={utilisateur} />,
        'creation_en_masse_csv': <UtilisateursCreationEnMasse utilisateur={utilisateur} />,
        'consultation': <UtilisateurVue utilisateur={utilisateur} />,
        'default': <UtilisateurVue utilisateur={utilisateur} />
    };
    const ComponentToRender = modeOptions[mode] || modeOptions['default'];

    const navigate = useNavigate();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/utilisateurs/${utilisateurId}`);

                if (!response.data.success) {
                    return handleError("Une erreur est survenue");
                }

                const parseData = response.data.myUtilisateur;
                setMyApiData(parseData);
                setUtilisateur(response.data.myUtilisateur);
            } catch (error) {
                console.error('error', error);
                if (error.response) {
                    navigate('/admin/utilisateurs');
                }
            }
        })();
    }, [utilisateurId, user, mode]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ utilisateur }));
    }, [utilisateur]);

    return (
        <div className="content">
            <TitleMain text={`${utilisateur.prenom} ${utilisateur?.nom?.toUpperCase()}`}/>

            {ComponentToRender}

        </div>
    )
}

export default AdminUtilisateurPage;
